import { render } from "./HomeHero.vue?vue&type=template&id=5038850c&scoped=true"
import script from "./HomeHero.vue?vue&type=script&lang=js"
export * from "./HomeHero.vue?vue&type=script&lang=js"

import "./HomeHero.vue?vue&type=style&index=0&id=5038850c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5038850c"]])

export default __exports__